import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../../styles/Navbar.css';
import { PrimaryButton } from '../../../ui/components/buttons';
import { useI18n } from '../../../i18n/I18nProvider';
import jidduLogo from '../../../images/Logo/JidduFilms_Logo_White.png';

const Navbar = ({ userLogout }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const { language, changeLanguage, t } = useI18n();
  const location = useLocation();
  
  // Solo aplicar el comportamiento de ocultar navbar en el homepage
  const isHomepage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      // Solo ocultar el navbar en el homepage cuando esté en la parte superior
      if (isHomepage) {
        setIsScrolled(window.scrollY > 20);
      } else {
        // En otras páginas, el navbar siempre debe estar visible
        setIsScrolled(true);
      }
    };

    // Inicializar el estado basado en la página actual
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isHomepage]);

  const scrollToContact = () => {
    const contactSection = document.querySelector('.contact-cta-two-column');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Funciones para cambio de idioma
  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsLanguageDropdownOpen(false);
  };

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  const handleMouseEnterLanguage = () => {
    setIsLanguageDropdownOpen(true);
  };

  const handleMouseLeaveLanguage = () => {
    setIsLanguageDropdownOpen(false);
  };

  // Determinar las clases CSS basadas en la página y el scroll
  const getNavbarClasses = () => {
    const baseClasses = 'navbar';
    
    if (isHomepage) {
      // En homepage: ocultar cuando está en top, mostrar cuando hace scroll
      return `${baseClasses} ${isScrolled ? 'navbar--scrolled navbar--visible' : 'navbar--hidden'}`;
    } else {
      // En otras páginas: siempre visible con fondo sólido
      return `${baseClasses} navbar--visible navbar--scrolled`;
    }
  };

  return (
    <nav className={getNavbarClasses()}>
      <div className="navbar__container">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
          <img 
            src={jidduLogo} 
            alt="Jiddu Films" 
            className="navbar__logo-img"
          />
        </Link>

        {/* Actions - Language Links + CTA Button */}
        <div className="navbar__actions">
          {/* Language Dropdown */}
          <div 
            className="navbar__language"
            onMouseEnter={handleMouseEnterLanguage}
            onMouseLeave={handleMouseLeaveLanguage}
          >
            <button className="navbar__language-btn">
              {language === 'es' ? 'ESPAÑOL' : 'ENGLISH'}
              <span className="navbar__language-arrow">▼</span>
            </button>
            
            {isLanguageDropdownOpen && (
              <div className="navbar__language-dropdown">
                <button 
                  className={`navbar__language-dropdown-item ${language === 'es' ? 'navbar__language-dropdown-item--active' : ''}`}
                  onClick={() => handleLanguageChange('es')}
                >
                  ESPAÑOL
                </button>
                <button 
                  className={`navbar__language-dropdown-item ${language === 'en' ? 'navbar__language-dropdown-item--active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  ENGLISH
                </button>
              </div>
            )}
          </div>

          {/* CTA Button */}
          <PrimaryButton 
            onClick={scrollToContact}
            title={t('navbar.connect')}
            className="navbar__cta-btn"
          >
            {t('navbar.connect')}
          </PrimaryButton>
        </div>
      </div>

    </nav>
  );
};

export default Navbar;
